import api from "../services/index";

const regularizationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    fetchRegularizationStatus: builder.mutation({
      query: (body) => ({
        url: "/api/attendance/regularization/status",
        method: "POST",
        body,
      }),
    }),
    applyRegularization: builder.mutation({
      query: (body) => ({
        url: "/api/attendance/regularization/apply",
        method: "POST",
        body,
      }),
    }),
    getAssociatedManager: builder.query({
      query: (employeeId) => ({
        url: "/api/attendance/regularization/fetch/associated/manager",
        method: "GET",
        params: { employeeId },
      }),
    }),
    getRegularizationHistory : builder.query({
      query: (isEmployee) => ({
        url: "/api/attendance/regularization/history",
        method: "GET",
        params: { isEmployee },
      }),
    }),
    getPendingRegularization : builder.query({
      query: (isEmployee) => ({
        url: "/api/attendance/regularization/pending/status",
        method: "GET",
        params: { isEmployee },
      }),
      providesTags: ["approveRejectWithdrawRegularization"]
    }),
    setRegularizationUpdate : builder.mutation({
      query: ({regularizationId, body}) => ({
        url: "/api/attendance/regularization/update",
        method: "PUT",
        body,
        params: { regularizationId },
      }),
      invalidatesTags: ["approveRejectWithdrawRegularization"]
  }),
})
});

export default regularizationApi;
export const {
  useFetchRegularizationStatusMutation,
  useApplyRegularizationMutation,
  useGetAssociatedManagerQuery,
  useLazyGetRegularizationHistoryQuery,
  useLazyGetPendingRegularizationQuery,
  useSetRegularizationUpdateMutation
} = regularizationApi;
